import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
    toastr.success(context.$t('groups.delete_success'));
    context.getGroups();
    context.selectedGroup = {
        ids: [],
        name: '',
        rentals: []
    }
};

// When the request fails
const failed = (error) => {
    toastr.error(error);
};

export default (context, id) => {
    return Vue.$http.delete('/groups/' + id,)
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context);
            } else {
                failed(error, context);
            }
        }).catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/deleteGroup.js